import typeCheck from './typeCheck.js'
export default {
    Objetos: {
        extractColumnFromArray(arr, column) {
            return arr.map(x => x[column])
        },

        async when(condition, callback, callbackTimeout = undefined, timeout = 10000, interval = 2) {
            return new Promise(async (resolve) => {
                if (await condition()) {
                    resolve(await callback());
                    return;
                }

                let timeoutId = setTimeout(async () => {
                    clearInterval(intervalId);
                    resolve(callbackTimeout ? await callbackTimeout() : null)
                }, timeout);

                let intervalId = setInterval(async () => {
                    if (await condition()) {
                        if (intervalId) clearInterval(intervalId);
                        if (timeoutId) clearTimeout(timeoutId);

                        resolve(await callback());
                    }
                }, interval);
            });
        },

        async whenDefined(object, property, callback, callbackTimeout = undefined, timeout = 10000) {
            await this.when(() => { return object[property] != undefined }, () => { callback(object, property, object[property]) }, callbackTimeout, timeout);
        },

        async when2({ condition, callback, callbackTimeout = undefined, timeout = 10000, interval = 2 }) {
            return new Promise(async (resolve) => {
                await this.when(condition, callback, callbackTimeout, timeout, interval);
                resolve();
            });
        },

        ...typeCheck
    }
}

